import { clients } from '../../https';
import {
  GetPreSignedUrlForUploadPayload,
  GetPreSignedUrlForUploadResponse,
} from '../types/storage.types';
import { getConfigurationSettings } from 'services/configuration-service';
import { ModuleName } from 'constant/modules.constants.ts';

export const getPreSignedUrlForUpload = async (
  payload: GetPreSignedUrlForUploadPayload,
  blocksKey: string,
  options?: { checkLibraryStorage?: boolean }
): Promise<GetPreSignedUrlForUploadResponse> => {
  const config = await getConfigurationSettings();
  const body = {
    itemId: '',
    tags: '',
    metaData: '',
    parentDirectoryId: '',
    accessModifier: 'Private',
    configurationName: 'Default',
    moduleName: ModuleName.AICloud,
    ...payload,
  };
  // Chat attachments and KB files go through our backend so the library storage
  // limit is checked before a slot is issued. Agent images and other uploads
  // still call storage directly — they are not library quota.
  const url = options?.checkLibraryStorage
    ? `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.presignedUrl}`
    : `${config.paths.logicBaseUrl}/Storage/GetPreSignedUrlForUpload`;
  const response = await clients.post<GetPreSignedUrlForUploadResponse>(
    url,
    blocksKey,
    JSON.stringify(body)
  );
  return response;
};

/** Tells the backend which uploads finished, so it can read their sizes and record them. */
export const completePreSignedUpload = async (
  fileIds: string[],
  blocksKey: string
): Promise<{ recorded: number }> => {
  const config = await getConfigurationSettings();
  return clients.post<{ recorded: number }>(
    `${config.paths.seliseAiBaseUrl}${config.paths.seliseAi.presignedUrlComplete}`,
    blocksKey,
    JSON.stringify({ fileIds })
  );
};

/**
 * Records finished uploads without failing the attachment: the bytes are stored
 * either way, so a metering miss must not roll back a successful blob PUT.
 */
export const recordCompletedPresignedUpload = async (
  fileIds: string[],
  blocksKey: string
): Promise<{ recorded: number }> => {
  try {
    return await completePreSignedUpload(fileIds, blocksKey);
  } catch (err) {
    console.error('Recording the upload failed:', err);
    return { recorded: 0 };
  }
};
